import { render, staticRenderFns } from "./UserAgeTrend.vue?vue&type=template&id=4fffaf8f&scoped=true&"
import script from "./UserAgeTrend.vue?vue&type=script&lang=js&"
export * from "./UserAgeTrend.vue?vue&type=script&lang=js&"
import style0 from "./UserAgeTrend.vue?vue&type=style&index=0&id=4fffaf8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fffaf8f",
  null
  
)

component.options.__file = "UserAgeTrend.vue"
export default component.exports